import type { FaireProductEntity } from "../../entity_types/product";

export const p_9ysmjsv289: FaireProductEntity = {
  token: "p_9ysmjsv289",
  type: "product",
  name: "Astrology Made Me Do It Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/0a548d364452a6d56fe48e8ba84ac8732194a7e44da67eba0a75a935474a317c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fc93fcca6ebf353d2bf5130e8b46c7e2465a18e73b94a45025d7244f4af96085.jpeg",
    "https://cdn.faire.com/fastly/ed38f0a4a75b0ce0627a8a02f48d1b6e3adc37834d9177b36b37a569f46b2651.jpeg",
    "https://cdn.faire.com/fastly/3939c9867e98def82bdff61083c489236c52c57662dbda2375eed30b3a29605d.jpeg",
    "https://cdn.faire.com/fastly/b8fa2d6916a8022d867fc5b6f8c5127c047423948a55493442ed9c274b767e4f.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks are for the friend who can always, always, always, blame Mercury being in retrograde.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:58.489Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
